import * as React from 'react';

/**
 * Client-side redirect to an external URL. Used for vanity routes (e.g. /hiring)
 * that point off-site. Uses `location.replace` so the redirect route doesn't
 * land in the browser's history (Back skips past it). Renders a small fallback
 * with a manual link in case the scripted redirect is slow or blocked.
 */
export function ExternalRedirect({ to }: { to: string }) {
  React.useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <div className="grid min-h-screen place-items-center bg-white px-6 text-center text-sm text-ink-500">
      <p>
        Redirecting…{' '}
        <a
          href={to}
          className="text-ink-900 underline underline-offset-4 hover:text-ember-600"
        >
          Continue
        </a>
      </p>
    </div>
  );
}
